import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

import API_RESPONSE_CODE from "@constants/api.response.code";

import { combineClassNames } from "@utils/appUtils";

import DuPont_logo from "@common/assets/images/DuPont_Logo_SVG.svg";
import Wave_Pro_Logo from "@common/assets/images/WAVE_Pro_Logo_Text.svg";

const LogoContainer = styled.div`
  display: flex;
  gap: 30px;

  a,
  img {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

const WaveProBrandLogo = ({ handleNavigate }) => {
  const apiError = useSelector(state => state.apiData.apiError);
  const { pathname } = useLocation();

  const isHomeNavigationDisabled = useMemo(
    () => pathname === "/about" || pathname === "/help" || apiError?.status === API_RESPONSE_CODE.ACCESS_DENIED,
    [pathname, apiError],
  );

  return (
    <LogoContainer>
      <a href='https://www.dupont.com/water.html' target='__blank'>
        <img src={DuPont_logo} alt='Dupont Logo' />
      </a>
      <img
        src={Wave_Pro_Logo}
        alt='WavePro Logo'
        onClick={handleNavigate}
        className={combineClassNames(isHomeNavigationDisabled && "cursor-default")}
      />
    </LogoContainer>
  );
};

export default WaveProBrandLogo;
